import { createSlice, createAction } from "@reduxjs/toolkit";
import { RootState } from "store/store";
import { Candidate, CandidateQueryParams } from "../type";

interface CareerPostsState {
	list: Array<Candidate>;
  total: number;
}

const initialState: CareerPostsState = {
	list: [],
  total: 0,
};

export const candidateSlice = createSlice({
	name: "candidate",
	initialState,
	reducers: {
		setListCandidates: (state, action) => {
			state.list = action.payload.data;
			state.total = action.payload.total;
		},
	},
});

export const selectListCandidates = (state: RootState) =>
	state.candidate.list;
export const selectCandidateTotal = (state: RootState) =>
	state.candidate.total;

export const { setListCandidates } = candidateSlice.actions;

export interface GetListCandidateAsyncPayload {
	query: CandidateQueryParams;
	callback?: () => void;
}

export const getListCandidatesAsync = createAction(
	"candidate/getListCandidates",
	(payload: GetListCandidateAsyncPayload) => ({
		payload: payload || {},
	}),
);

export default candidateSlice.reducer;
